export enum Collections {
  USERS = "users",
  PAGES = "pages",
  NEWS = "news",
  QUESTIONS = "questions",
  NOTIFICATIONS = "notifications",
}
